"use client"
import type React from "react"
import { createContext, useContext, useMemo } from "react"
import type { LinkProps } from "../../server"

type NavigationContext = {
  renderLink: React.ComponentType<LinkProps> | undefined
}

export const NavigationContext = createContext<NavigationContext>({
  renderLink: undefined,
})

/**
 * Props for NavigationProvider component
 * @public
 */
export type NavigationProviderProps = Partial<NavigationContext> & {
  children: React.ReactNode
}

export function NavigationProvider({
  children,
  renderLink,
}: NavigationProviderProps) {
  const value = useMemo(() => ({ renderLink }), [renderLink])

  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  )
}

export function useNavigation() {
  return useContext(NavigationContext)
}
